import React, { useEffect, useState } from "react";
import { Space, Card, Layout } from "antd";
import SideBar from "./_sideBar";
import CopyRight from "./CopyRight";
import { CreditCardOutlined, MenuOutlined } from "@ant-design/icons";

const { Content } = Layout;

const UnauthorizedPage = () => {
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [nextMenuDisabled, setNextMenuDisabled] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SideBar
        menuDisabled={menuDisabled}
        nextMenuDisabled={nextMenuDisabled}
        fontSize="14px"
        drawerVisibleValue={drawerVisible}
        setDrawerVisibleValue={setDrawerVisible}
      />

      <Layout className="site-layout">
        <Content>
          <div className="site-layout-background" style={{ minHeight: 360 }}>
            <Space
              direction="vertical"
              style={{ padding: "10px", width: "100%" }}
            >
              <Card
                title={
                  <span>
                    {isMobile && (
                      <MenuOutlined
                        onClick={() => setDrawerVisible((prev) => !prev)}
                        style={{ marginRight: 8, fontSize: 30 }}
                      />
                    )}
                    Unauthorized Access
                  </span>
                }
              >
                <h1>Unauthorized Access</h1>
                <p>You do not have permission to access this page.</p>
              </Card>
            </Space>
          </div>
          <CopyRight />
        </Content>
      </Layout>
    </Layout>
  );
};

export default UnauthorizedPage;
